
import React, { useState, useEffect } from 'react';

import { createContext, useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { withAuthenticator, Button, Heading, View, Flex, Text, Input, TextAreaField, Image, Link, Icon, Card, Loader } from '@aws-amplify/ui-react';
import { withSession, withSessionOr } from '../../components/context/CurrentUserContext';

import { Expander, ExpanderItem } from '@aws-amplify/ui-react';

import { getVideoDetails } from "../../services/youtube/YoutubeJsService"

import { Table, TableHead, TableRow, TableCell, TableBody } from '@aws-amplify/ui-react';

import { FaBeer } from 'react-icons/fa';

const Home = () => {

  const [videoId, setVideoId] = useState(null);
  const [url, setUrl] = useState(null);

  let { error, setError } = useError();


  useEffect(() => {


    setUrl("https://www.youtube.com/watch?v=uiTrB-zA7bc")


  }, [])


  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {

      if (!url.startsWith("https://www.youtube.com/watch?v=")) {
        setError("Invalid Url");
        return
      }

      let v = url.substr(32);
      setVideoId(v);
    }
  }




  const handleInput = (e) => {
    const { name, value } = e.target;
    console.log('do validate:' + value)

    if (videoId) {
      setVideoId(null)
    }

    if (error) {
      setError(null)
    }

    setUrl(value);
  };




  return (
    <CustomFrame>
      <>
        {/* <Text
          variation="primary"
          as="p"
          lineHeight="2em"
          fontWeight={400}
          fontSize="2em"
          fontStyle="normal"
          textDecoration="none"
          width="30vw"
        >
          Video details
        </Text> */}

        <Flex direction="column">

          <Text variation="tertiary" color={'darkblue'}>URL</Text>
          <Input variation="tertiary" onChange={e => handleInput(e)} onKeyDown={handleKeyDown}></Input>
          <ErrorMessage error={error} />

          {/* <p>url:{url}</p>
          <p>videoId:{videoId}</p> */}

          {videoId ? <VideoDetails videoId={videoId} /> : <></>}


        </Flex>
      </>
    </CustomFrame>


  );
};



const VideoDetails = ({ videoId }) => {

  const [video, setVideo] = useState(null);
  let { error, setError } = useError();

  const [load, setLoad] = useState(false);


  const onUpdate = async () => {

    setError(null)
    setVideo(null)

    try {

      const data = await getVideoDetails(videoId);
      setVideo(data)
      setLoad(false)

    } catch (err) {
      console.error("error: " + err.message);
      setError("error: " + err.message);
      setVideo(null);
      setLoad(false)
      return;
    }
  }


  useEffect(() => {
    (async () => {
      setLoad(true)
      onUpdate(videoId)
    })();
  }, [videoId])

  return (<>

    {load ? <Loader size="large" /> :

      <>

        <ErrorMessage error={error} />

        <IfElse condition={!error}>
          <IfElse condition={video && video.details}>
            <>
              <Flex direction="column">

                <VideoThumbnail details={video ? video.details : null} />


                <Text variation="tertiary" color={'darkblue'} >Id</Text>
                <Input variation="tertiary" value={videoId} readOnly={true}></Input>


                <Text variation="tertiary" color={'darkblue'} >Title</Text>
                <Input variation="tertiary" value={video && video.details ? video.details.title : ''} readOnly={true}></Input>


                <DefaultAccordionExample title={"Description"}>
                  <TextAreaField variation="tertiary" value={video && video.details ? video.details.description : ''} readOnly={true} rows={10} />
                </DefaultAccordionExample>


                <DefaultAccordionExample title={"Channel"}>
                  <ChannelDetails details={video && video.details ? video.details : null} />
                </DefaultAccordionExample>


                <DefaultAccordionExample title={"Thumbnails"}>
                  <VideoThumbnails details={video && video.details ? video.details : null} />
                </DefaultAccordionExample>


                <DefaultAccordionExample title={"Formats"}>
                  <VideoFormats formats={video && video.formats ? video.formats : null} />
                </DefaultAccordionExample>


              </Flex>
            </>
          </IfElse>
        </IfElse>
      </>
    }

  </>
  )
}


export const ChannelDetails = ({ details }) => {

  return (

    <>
      {details && details.author ?

        <>
          <Card>
            <Image
              alt="Amplify logo"
              src={details.author.thumbnails[0].url}
              objectFit="initial"
              objectPosition="50% 50%"
              backgroundColor="initial"
              height={details.author.thumbnails[0].height}
              width={details.author.thumbnails[0].width}
              opacity="100%"
              onClick={() => alert('📸 Say cheese!')}
            />

            <Image
              alt="Amplify logo"
              src={details.author.thumbnails[1].url}
              objectFit="initial"
              objectPosition="50% 50%"
              backgroundColor="initial"
              height={details.author.thumbnails[1].height}
              width={details.author.thumbnails[1].width}
              opacity="100%"
              onClick={() => alert('📸 Say cheese!')}
            />

            <p>Channel id: {details.author.id}  </p>
            <Link href={details.author.channel_url} >{details.author.channel_url}</Link>


            <p>user id: {details.author.id} </p>

            <Link href={details.author.user_url} >{details.author.user_url}</Link>

            <p>Subs: {details.author.subscriber_count}</p>
          </Card>

        </>
        : <></>
      }
    </>
  );

};

export const VideoThumbnail = ({ details }) => {

  return (

    <>
      {details && details.thumbnails && details.thumbnails.length > 0 ?

        <>
          <Image
            alt="Amplify logo"
            src={details.thumbnails[0].url}
            objectFit="initial"
            objectPosition="50% 50%"
            backgroundColor="initial"
            height={details.thumbnails[0].height}
            width={details.thumbnails[0].width}
            opacity="100%"
            onClick={() => alert('📸 Say cheese!')}
          />


        </>
        : <></>
      }
    </>
  );

};



export const VideoFormats = ({ formats }) => {

  return (

    <>

      <Table
        caption=""
        highlightOnHover={false}>
        <TableHead>
          <TableRow>
            <TableCell as="th">itag</TableCell>
            <TableCell as="th">container</TableCell>
            <TableCell as="th">mimetype</TableCell>
            <TableCell as="th">Quality</TableCell>
            <TableCell as="th">Bitrate</TableCell>

            <TableCell as="th">Action</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {formats && formats.length > 0 ?

            formats.map((ff) => (


              <TableRow>
                <TableCell>{ff.itag}</TableCell>
                <TableCell>{ff.container}</TableCell>
                <TableCell>{ff.mimeType}</TableCell>
                <TableCell>{ff.qualityLabel}</TableCell>
                <TableCell>{ff.bitrate}</TableCell>

                <TableCell>

                  <>
                    {ff.hasVideo ? <Link href={ff.url} isExternal={true} >open</Link> : <> </>}
                    {!ff.hasVideo ? <>
                      <audio controls>

                        <source src={ff.url} type="audio/mpeg" />
                        Your browser does not support the audio element.
                      </audio>
                    </> : <> </>}
                  </>

                </TableCell>

              </TableRow>


            )) : <>  </>
          }
        </TableBody>
        : <></>

      </Table>
    </>
  );

};



export const VideoThumbnails = ({ details }) => {

  return (

    <>
      {details && details.thumbnails && details.thumbnails.length > 0 ?



        details.thumbnails.map((image) => (
          <Link href={image.url} isExternal={true} >WxH {image.with} x {image.height}</Link>
        ))

        : <></>
      }
    </>
  );

};


export const DefaultAccordionExample = ({ title, children }) => {

  const [show, setShow] = useState(false);

  return (

    <>
      <Flex direction="row">

        <Text
          variation="secondary"
          as="p"
          lineHeight="2em"
          fontWeight={400}
          fontSize="1em"
          fontStyle="normal"
          textDecoration="none"
          width="30vw"
        >{title} </Text>
        <Text
          color={'blue'}
          variation="secondary"
          as="p"
          lineHeight="2em"
          fontWeight={400}
          fontSize="1em"
          fontStyle="normal"
          textDecoration="none"
          width="30vw"
          onClick={() => setShow(!show)}
        > {!show ? "Show" : "Hide"} </Text>
      </Flex>
      {show ? <>{children}</> : <></>}
    </>

  );
};


export const ErrorMessage = ({ error }) => {

  return (
    error ?
      <Text variation="error" color={'red'}>{error}</Text>
      :
      <></>
  );

};


export const IfElse = ({ condition, children }) => {

  return (
    // condition ?
    // <></>
    // :
    // <></>

    <>
      {condition ? children : <></>}
    </>
  );

};




const CustomFrame = ({ children }) => {


  return (
    <View
      as="div"
      ariaLabel="View example"
      backgroundColor="var(--amplify-colors-white)"
      // borderRadius="6px"
      // border="1px solid var(--amplify-colors-black)"
      // boxShadow="3px 3px 5px 6px var(--amplify-colors-neutral-60)"
      // color="var(--amplify-colors-blue-60)"
      // height="20rem"
      maxWidth="100rem"
      padding="0.5rem"
      width="50rem"
    >
      {children}
    </View>
  );
};


function useError() {
  const [error, setError] = useState(null);

  return { error, setError };
}


export default Home;

